import React from 'react';
import Spinner from '../../common/components/Spinner';
import Header from './Header';
import Footer from '../../Footer';
import Navigation from './Navigation';

const BOUsers = () => {

    return (
        <main className='App' style={{ color: "white", backgroundColor: "#6B747F" }}>

            <React.Fragment>                
                <table width={"100%"}>
                    <tbody>
                        <tr>
                            <td><Header /></td>
                        </tr>
                        <tr><td></td><td></td></tr>
                        <tr>
                            <td colSpan={2} style={{ verticalAlign: "top", paddingTop: "50px", paddingBottom: "50px" }}><Navigation /></td>
                        </tr>
                        <tr>
                            <td colSpan={2}><Footer /></td>
                        </tr>
                    </tbody>
                </table>
                <Spinner />
            </React.Fragment>
        </main>
    );
};

export default BOUsers;